<script lang="ts" setup>
const localStorageStore = useLocalStorageStore();
const props = defineProps(['modelValue', 'label']);
const search = ref('');

const emit = defineEmits();
const airports = ref<any>({});
const internationalAirports = ref<any>({})
const input = ref('');
const airportMapping = ref<any>({ city: {}, id: {},name: {} });

const getAirports = async()  => {
  try{
    const response: any = localStorageStore.getInternationalAirport();
    airports.value = response
    internationalAirports.value = response

    airportMapping.value = response.reduce((map: any, airport: any) => {
        map.id[airport.id] = airport.id;
        map.city[airport.id] = airport.city;
        map.name[airport.id] = airport.name;
        return map;
      }, { id: {},city: {},name: {} });
  }catch(error){
    console.error(error)
  }
}

const focusSearch = () => {
  nextTick(() => {
    let element = null;
    element = input.value;
    
    if (element) {
      setTimeout(() => {
        element.focus();
      }, 100); // Adjust the delay if necessary
    }
  });
};

watch(search, () => {
  if (!search.value) {
    airports.value = localStorageStore.getInternationalAirport();
  } else {
    const filteredAirports = internationalAirports.value.filter((airport: { name: string; id: string; city: string; country: string; alias: string; }) =>
      airport.name.toLowerCase().includes(search.value.toLowerCase()) ||
      airport.id.toLowerCase().includes(search.value.toLowerCase()) ||
      airport.city.toLowerCase().includes(search.value.toLowerCase()) ||
      airport.country.toLowerCase().includes(search.value.toLowerCase()) ||
      airport.alias?.toLowerCase().includes(search.value.toLowerCase()) // Pencarian berdasarkan alias
    );

    // Prioritize by airport id first
    airports.value = filteredAirports.sort((a, b) => {
      const searchTerm = search.value.toLowerCase();
      const aMatchesId = a.id.toLowerCase().includes(searchTerm);
      const bMatchesId = b.id.toLowerCase().includes(searchTerm);
      
      // Sort id matches first
      if (aMatchesId && !bMatchesId) return -1;
      if (!aMatchesId && bMatchesId) return 1;
      return 0; // Otherwise, maintain current order
    });
  }
});

onMounted(() => {
  getAirports();
});

const clearSearch = () => {
  search.value = ''; // Clear search input
};

const select = (airport: any) => {
  emit('update:modelValue', airport);
  search.value = '';
};
</script>

<template>
    <div class="input-container">
      <label for="dropdownKotaAsal">{{ props.label }}</label>
      <div class="dropdown input-group mb-3" @hidden.bs.dropdown="clearSearch">
        <button
          class="form-control rounded text-start"
          type="button"
          id="dropdownKotaAsal"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          @click="focusSearch()"
        >
            {{ Object.keys(props.modelValue).length === 0 ? `${props.label} Bandara` : props.modelValue?.name ? `${props.modelValue?.name} (${props.modelValue?.id})` : `${airportMapping.name[props.modelValue]} (${props.modelValue})` }}
        </button>
        <ul class="dropdown-menu pt-0 w-100" aria-labelledby="dropdownKotaAsal">
          <div class="bg-white sticky-top py-1">
            <input
              type="text"
              class="form-control border border-1 rounded shadow-none m-2"
              v-model="search"
              style="
                max-width: calc(100% - 16px);
                top: 0;
              "
              ref="input"
              placeholder="Search..."
            />
          </div>
          <div class="scrollable-menu ms-2">
            <li
              v-for="airport in airports"
              :key="airport.id"
              style="cursor:pointer;"
              @click="select(airport)"
            >
              <label>{{ airport.name }}</label>
              <span class="badge bg-primary">{{ airport.id }}</span>
              <div style="display: block">
                <small class="text-default"
                  ><em>{{ `${airport.city}, ${airport.country}` }}</em></small
                >
              </div>
            </li>
          </div>
        </ul>
      </div>
    </div>
</template>

<style scoped>
/* .d-flex {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.input-container {
  flex: 1;
} */

.form-select {
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

/* .swap-button {
  display: flex;
  align-items: center;
  justify-content: center;
}

.swap-button .btn {
  padding: 0.5rem;
} */

.dropdown button:hover {
  cursor: pointer;
}

.scrollable-menu {
  max-height: 200px;
  overflow-y: scroll;
  scrollbar-width: none; /* For Firefox */
  -ms-overflow-style: none; /* For Internet Explorer and Edge */
}

.scrollable-menu::-webkit-scrollbar {
  display: none; /* For Chrome, Safari, and Opera */
}

.scrollable-menu li {
  display: block;
  position: relative;
  padding: 8px;
  width: 100%;
}

.scrollable-menu li .badge {
  position: absolute;
  right: 8px;
  top: 33%;
  transform: translateY(-50%);
}

.scrollable-menu li:hover {
  background-color: #f8f9fa;
}
</style>